module.exports = __webpack_public_path__ + "statics/img/4-2.56915fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/4-2.png
// module id = Ohue
// module chunks = 1